import React, { useEffect, useRef, useState } from 'react';
import { registerDialogListener } from '../utils/dialogService';
import './DialogHost.css';

// Single on-page modal that answers confirmDialog()/promptDialog() calls from
// anywhere in the app, replacing window.confirm()/window.prompt(). Mounted
// once near the app root (see App.js).
const DialogHost = () => {
  const [request, setRequest] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    registerDialogListener((nextRequest) => {
      setInputValue(nextRequest.defaultValue || '');
      setRequest(nextRequest);
    });
    return () => registerDialogListener(null);
  }, []);

  useEffect(() => {
    if (request?.type === 'prompt' && inputRef.current) inputRef.current.focus();
  }, [request]);

  if (!request) return null;

  const finish = (value) => {
    request.resolve(value);
    setRequest(null);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') finish(request.type === 'confirm' ? false : null);
    if (event.key === 'Enter' && request.type === 'prompt') finish(inputValue);
  };

  return (
    <div className="eulua-dialog-overlay" role="presentation" onKeyDown={handleKeyDown}>
      <div
        className={`eulua-dialog-card eulua-dialog-card--${request.tone || 'default'}`}
        role={request.type === 'confirm' ? 'alertdialog' : 'dialog'}
        aria-modal="true"
      >
        <p className="eulua-dialog-message">{request.message}</p>

        {request.type === 'prompt' && (
          <input
            ref={inputRef}
            type="text"
            className="eulua-dialog-input"
            value={inputValue}
            onChange={(event) => setInputValue(event.target.value)}
          />
        )}

        <div className="eulua-dialog-actions">
          <button
            type="button"
            className="eulua-dialog-button eulua-dialog-button--secondary"
            onClick={() => finish(request.type === 'confirm' ? false : null)}
          >
            {request.cancelLabel || 'Cancel'}
          </button>
          <button
            type="button"
            className="eulua-dialog-button eulua-dialog-button--primary"
            onClick={() => finish(request.type === 'confirm' ? true : inputValue)}
          >
            {request.confirmLabel || (request.type === 'prompt' ? 'Submit' : 'Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogHost;
